<template>
  <div class="bg-beige-lighter pt-4 pl-4">
    <p @click="$emit('close')" class="btn-close">
      <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><rect height="1" rx=".5" transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.010408 -4.146447)" width="16" x="2.010408" y="9.510408"/><rect height="1" rx=".5" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -4.146447 10.010408)" width="16" x="2.010408" y="9.510408"/></g></svg>
    </p>
    <ul class="place-list flex overflow-x-scroll mt-4">
      <template v-if="loading">
        <li v-for="n in dummies" v-bind:key="n">
          <place-loading />
        </li>
      </template>
      <template v-else>
        <li v-for="duration in durations" v-bind:key="duration.place.id">
          <place :duration="duration" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Place from './Place'
import PlaceLoading from './PlaceLoading'
import _ from 'lodash'

export default {
  components: {
    Place,
    PlaceLoading
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      durations: 'map/getDurations'
    }),
    dummies: function () {
      return _.range(10)
    }
  },
  watch: {
    durations: function (val) {
      if (val.length > 0) {
        this.loading = false
      } else {
        this.loading = true
      }
    }
  }
}
</script>
